<template>
    <div>
        <div class="google-map" ref="googleMap" v-bind:style="{ width: '100%', height: '800px' }"></div>
        <div class="alert alert-danger" v-if="selectedOrders.length === 0">Alege cel putin o comanda</div>
        <div class="card-header d-flex justify-content-between">
            <span>Lista comenzi selectate</span>
            <strong>Total: {{ selectedOrders.length }}</strong>
        </div>
        <div class="card-body p-0">
            <table class="table table-striped">
                <thead class="thead-dark">
                <tr>
                    <th scope="col">Ordine</th>
                    <th scope="col">ID</th>
                    <th scope="col">Referinta</th>
                    <th scope="col">Client</th>
                    <th scope="col">Adresa</th>
                    <th scope="col">Data comanda</th>
                    <th scope="col">Total</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(selectedOrder, position) in selectedOrders">
                    <td>{{ position + 1 }}</td>
                    <td>{{ selectedOrder.id }}</td>
                    <td>{{ selectedOrder.reference }}</td>
                    <td>
                        {{ selectedOrder.last_name }} {{ selectedOrder.first_name }} <br>
                        <small>{{ selectedOrder.email }}</small><br>
                        <small>{{ selectedOrder.phone }}</small>
                    </td>
                    <td>
                        {{ selectedOrder.full_address }}<br>
                    </td>
                    <td>{{ selectedOrder.created_at }}</td>
                    <td>
                        {{ selectedOrder.total / 100 }} RON<br>
                        <small>Transport {{ selectedOrder.transport / 100 }} RON</small>
                    </td>
                    <td>
                        <a class="btn btn-sm btn-outline-primary" v-bind:href="'/admin/orders/' + selectedOrder.id + '/edit-cart'" target="_blank">Vezi</a>
                        <button v-if="!isDeliveryDone()" class="btn btn-sm btn-outline-dark" @click="toggleOrder(selectedOrder.id)">Sterge</button><br>
                        <span v-if="selectedOrder.status_payment === 0" class="badge bg-warning text-dark">Plata in asteptare</span>
                        <span v-if="selectedOrder.status_payment === 1" class="badge bg-success">Plata receptionata</span>
                        <span v-if="selectedOrder.status_payment === 2" class="badge bg-danger">Plata esuata</span>
                        <span v-if="selectedOrder.status_delivery === 0" class="badge bg-warning text-dark">Comanda plasata</span>
                        <span v-if="selectedOrder.status_delivery === 1" class="badge bg-warning text-dark">Comanda programata</span>
                        <span v-if="selectedOrder.status_delivery === 2" class="badge bg-warning text-dark">Comanda pregatita</span>
                        <span v-if="selectedOrder.status_delivery === 3" class="badge bg-success">Comanda livrata</span>
                        <span v-if="selectedOrder.delivery_box_id !== null" class="badge bg-dark">Delivery Box</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="!isDeliveryDone()">
                <p class="text-muted m-2">Dupa salvare comenzile vor avea statusu <span class="badge bg-primary">Comanda pregatita</span></p>
                <button class="btn btn-sm btn-primary text-white m-2" @click="save()">
                    <div class="spinner-border spinner-border-sm" role="status" v-if="saving"></div>
                    Salveaza
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Loader } from '@googlemaps/js-api-loader'
    import MarkerClusterer from '@googlemaps/markerclustererplus'

    export default {
        props: {
            delivery: Object,
            apiKey: String,
            orders: Array
        },
        data () {
            return {
                saving: false,
                mapConfig: {
                    center: { lat: 45, lng: 23 },
                    zoom: 6
                },
                google: null,
                map: null,
                initialOrders: this.orders,
                selectedOrders: []
            }
        },
        async mounted () {
            new Loader({
                apiKey: this.apiKey,
                version: "weekly"
            }).load()
                .then(() => {
                    this.google = google;
                    this.initializeMap()
                })
                .catch(e => {
                    console.log(e)
                });
            this.selectedOrders = this.initialOrders.filter(order => order.selected).sort((a,b) => a.position - b.position)
        },
        methods: {
            isDeliveryDone () {
                return this.delivery.status === 1
            },
            pinSymbol (color) {
                return {
                    path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                    fillColor: color,
                    fillOpacity: 1,
                    strokeColor: '#000',
                    strokeWeight: 1,
                    scale: 1,
                    labelOrigin: new this.google.maps.Point(0, -30),
                }
            },
            initializeMap () {
                const mapContainer = this.$refs.googleMap
                this.map = new this.google.maps.Map(mapContainer, this.mapConfig)

                const bounds = new this.google.maps.LatLngBounds()

                const markers = this.initialOrders.map((order, index) => {
                    return this.loadMarkers(order, index, bounds)
                })

                this.map.fitBounds(bounds)
                this.map.setZoom(15)

                const markerCluster = new MarkerClusterer(this.map, markers, {
                    gridSize: 20,
                    maxZoom: 18,
                    zoomOnClick: true,
                    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
                })
            },
            loadMarkers (order, index, bounds) {
                const label = order.id
                const marker = new this.google.maps.Marker({
                    map: this.map,
                    draggable: true,
                    optimized: false,
                    icon: this.pinSymbol('red'),
                    label: label.toString(),
                    zIndex: -1
                })
                marker.setVisible(true)
                const myLatlng = new this.google.maps.LatLng(order.map_coordinates[0], order.map_coordinates[1])
                bounds.extend(new this.google.maps.LatLng(order.map_coordinates[0], order.map_coordinates[1]))
                marker.setPosition(myLatlng)

                if (order.selected) {
                    marker.setIcon(this.pinSymbol('green'))
                }
                this.$set(order, 'marker', marker)

                if (!this.isDeliveryDone()) {
                    marker.addListener('click', () => this.toggleOrder(order.id))
                }
                return marker
            },
            toggleOrder (orderId) {
                let index = this.initialOrders.findIndex(order => order.id === orderId)
                if (this.initialOrders[index].selected) {
                    this.initialOrders[index].marker.setIcon(this.pinSymbol('red'))
                    this.$set(this.initialOrders[index], 'selected', false)
                    //remove from selected
                    let selectedIndex = this.selectedOrders.findIndex(order => order.id === orderId)
                    this.selectedOrders.splice(selectedIndex, 1)
                } else {
                    this.initialOrders[index].marker.setIcon(this.pinSymbol('green'))
                    this.$set(this.initialOrders[index], 'selected', true)
                    this.selectedOrders.push(this.initialOrders[index])
                }
            },
            findSelectedOrder (id) {
                return this.initialOrders.findIndex(order => order.id === id)
            },
            save () {
                if (!this.saving) {
                    this.saving = true
                    axios.put('/admin/deliveries/' + this.delivery.id + '/updateOrders', this.selectedOrders.map((order, position) => {
                        return {
                            id: order.id,
                            position: position + 1
                        }
                    }))
                        .then(response => {
                            this.saving = false
                        })
                        .catch(error => {
                            console.log(error)
                            this.saving = false
                        })
                }
            }
        }
    }
</script>
